<template>
  <ClientOnly>
    <VTweet :theme="colorMode.value as 'light'|'dark'" align="center" dnt v-bind="passProps">
      <slot/>
    </VTweet>
  </ClientOnly>
</template>

<script lang="ts" setup>
import VTweet from "vue-tweet";

const colorMode = useColorMode();

const props = defineProps({
  id: {
    type: String,
    required: true
  },
});

const passProps = computed(() => {
  let {id, ...p} = {...props, 'tweet-id': props.id};
  return p;
});
</script>
